import React from "react"
import Layout from "../components/layout"
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import Image from "../components/image"
import Gift from "../components/gift";


const GalleryPage = () => (
  <Layout>
        <h1>Gratulerer med dagen Martine !!</h1>

     <div>
      <Breadcrumb tag="nav" listTag="div">
        <BreadcrumbItem tag="a" href="/">Home</BreadcrumbItem>
        <BreadcrumbItem tag="a" href="/gallery">Gallery</BreadcrumbItem>
        <BreadcrumbItem tag="a" href="#">Wishes</BreadcrumbItem>
        <BreadcrumbItem tag="a" href="/presents">Surprise</BreadcrumbItem>
      </Breadcrumb>
    </div> 
    <div class="row">

    <div class="col-12 justify-content-center">
    <Image alt="Gatsby in Space" filename="IMG_1575.jpeg" />
    </div>
    </div>

    <div class="row">
    <div class="col-12 mt-5 d-flex justify-content-left">
      <div class="box">
        <div class="box-body">
        <Gift/>
          <div class="box-lid">
            <div class="box-bowtie"></div>
          </div>
        </div>
      </div>
    </div>
 

    </div>
  </Layout>
)


export default GalleryPage
